// Legacy page destinations by parent_type, shared between ReminderDropdownMenu.js
// and taskHref.ts so the two don't drift. Paths are relative - callers prepend "/".
export const REMINDER_PARENT_HREF_BUILDERS: Partial<Record<string, (parentId: string) => string>> = {
  ORDER: (parent_id) => `order.php?id=${parent_id}`,
  CLIENT: (parent_id) => `client.php?id=${parent_id}`,
  'PURCHASE ORDER': (parent_id) => `purchase_order.php?id=${parent_id}`,
  SUPPLIER: (parent_id) => `vendor.php?id=${parent_id}`,
  'SUPPLIER-ACCOUNT': (parent_id) => `vendor.php?account_id=${parent_id}`,
  'TENANT-ACCOUNT': (parent_id) => `distributor.php?account_id=${parent_id}`,
  OPPORTUNITY: (parent_id) => `opportunity.php?id=${parent_id}`,
  PRESENTATION: (parent_id) => `presentation.php?id=${parent_id}`,
};
